import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  variant?: 'inline' | 'compact' | 'blocks';
};
const pad = (n: number) => String(n).padStart(2, '0');
export function Countdown({
  variant = 'blocks'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const label = `${hours} horas, ${minutes} minutos, ${seconds} segundos`;
  if (variant === 'inline') {
    return <span className="font-display font-semibold tabular-nums" aria-label={label} data-id="element-50" data-mp="3c12y4veo5lgz">
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>;
  }
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  const compact = variant === 'compact';
  return <div className={`flex items-start ${compact ? 'gap-1.5' : 'gap-2 sm:gap-3'}`} role="timer" aria-label={label} data-id="element-51" data-mp="10cbrzdzcmvd7">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-52" data-mp="15a50ido4k1gn" data-mpi={i}>
          {i > 0 && <span className={`font-display font-semibold text-mist ${compact ? 'pt-0.5 text-xl' : 'pt-2 text-3xl sm:text-4xl'}`} aria-hidden="true" data-id="element-53" data-mp="y0n2ls8ibfc5">:</span>}
          <div className="flex flex-col items-center" data-id="element-54" data-mp="szzaf38jksgc">
            <span className={`rounded-lg bg-night text-center font-display font-bold tabular-nums text-bone ring-1 ring-line ${compact ? 'min-w-[2.75rem] px-2 py-0.5 text-2xl' : 'min-w-[4.25rem] rounded-xl px-3 py-2 text-4xl sm:min-w-[5rem] sm:text-5xl'}`} data-id="element-55" data-mp="17py9r9bu29xe">
              {pad(u.value)}
            </span>
            <span className={`mt-1 font-semibold uppercase tracking-wider text-mist ${compact ? 'text-[10px]' : 'text-xs'}`} data-id="element-56" data-mp="o2qtt731kwh7">{u.label}</span>
          </div>
        </React.Fragment>)}
    </div>;
}